import React, { ChangeEvent, useState } from "react";
import { Link, useParams } from "react-router-dom";
import socketIOClient from "socket.io-client";
import { SocketEndpint } from "../../utils";
import { Button, InputField, Carousel } from "../../components";
import styles from "./index.module.scss";

export interface ParamType {
  roomId: string;
}

function Loading() {
  const parama: ParamType = useParams();
  const [state, setState] = useState({
    users: [],
    loggedIn: false,
    name: "",
    trivia: false,
  });

  const socket = socketIOClient(SocketEndpint);

  const { loggedIn, users, name, trivia } = state;

  return (
    <div className={styles.loadingParent}>
      <div className={styles.loadingContainer}>
        <div className={styles.showButton}>
          <Button
            name={"Show Info"}
            onClick={() => {
              setState({ ...state, trivia: true });
            }}
          />
        </div>
        <div className={styles.waitingDiv}>
          <h1>Waiting for others to join</h1>
          <div className={styles.loader}></div>
        </div>
        <br />
        <span>
          <h2>Room Code:</h2> <h3>{parama.roomId}</h3>
        </span>
        <br />
        {!!users?.length && <h2>Joined Persons</h2>}
        {users?.map((item: any) => (
          // <h3 key={item?.id}>{JSON.stringify(item)}</h3>
          <p key={item?.id}>{item?.name}</p>
        ))}
        {(!users?.length || !loggedIn) && (
          <div style={{ visibility: users?.length ? "hidden" : "visible" }}>
            <InputField
              placeholder="Enter Your Name"
              type="text"
              value={name}
              changeHandler={(e: ChangeEvent<HTMLInputElement>) => {
                setState({ ...state, name: e.target.value });
              }}
              style={{ width: "50vw" }}
            />
            <Button
              name="Join"
              onClick={() => {
                socket.emit(
                  "join",
                  {
                    name: name,
                    room: parama.roomId,
                  },
                  (data: any) => {
                    console.log(data);
                    if (data.users) {
                      setState({
                        ...state,
                        users: data.users,
                        loggedIn: false,
                      });
                    }
                  }
                );

                socket.on("notification", (data) => {
                  console.log("SOCKET", data);
                  console.log("SOCKEDUMB", data?.users);
                  setState({ ...state, users: data?.users, loggedIn: true });
                });

                console.log("Hide");
              }}
            />
          </div>
        )}
        {users?.length ? (
          <Link to={`/game/${parama.roomId}/${name}`}>
            <Button name="Start Game" />
          </Link>
        ) : (
          ""
        )}
      </div>
      {trivia && (
        <Carousel
          close={() => {
            setState({ ...state, trivia: false });
          }}
        />
      )}
    </div>
  );
}

export default Loading;
